export const MAX_IMAGE_SIZE_IN_MB = 10;
export const ALLOWED_IMAGE_EXTENSIONS = ['png', 'jpeg', 'jpg', 'pdf'];
